/**
 * hook: useTranslation()
 *
 * Allows for translatable strings in components, provided by the backend.
 */

import i18n from 'i18next';
import { useTranslation, initReactI18next } from 'react-i18next';

import getLang from 'Utils/getLang';

const { translations } = window.appConfig;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: translations,
    lng: getLang(),

    interpolation: {
      escapeValue: false,
    },
  });

export default useTranslation;
